import { render, staticRenderFns } from "./mobileDemand.vue?vue&type=template&id=548492ed&scoped=true"
import script from "./mobileDemand.vue?vue&type=script&lang=js"
export * from "./mobileDemand.vue?vue&type=script&lang=js"
import style0 from "./mobileDemand.vue?vue&type=style&index=0&id=548492ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548492ed",
  null
  
)

export default component.exports